import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  Optional,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DTOPODContact } from '../../../../../@core/models/DTOPODContact';
import { ShipmentService } from '../../../../../@core/services/shipment.service';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';
import { send } from 'process';

@Component({
  selector: 'crm-send-pod-dialog',
  templateUrl: './crm-send-pod-dialog.component.html',
  styleUrls: ['./crm-send-pod-dialog.component.scss']
})
export class CrmSendPodDialogComponent implements OnInit {
  shipmentId: number;
  customerId: number;
  emails: string;
  customerName: string;
  submitted: boolean;
  contactsNationex: DTOPODContact[];
  selectedContacts: DTOPODContact[];
  contactsText: string;
  userId: string;
  key: string;

  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  contactCtrl = new FormControl();
  filteredContacts: Observable<DTOPODContact[]>;
  contacts: string[] = [];
  //allFruits: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];

  @ViewChild('contactInput', { static: false })
  contactInput: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<CrmSendPodDialogComponent>,
    private ngZone: NgZone,
    private shipmentService: ShipmentService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shipmentId = data.ShipmentId;
    this.customerId = data.CustomerId;
    this.customerName = data.CustomerName;
    this.userId = data.userId;
    this.key = data.key;
  }

  ngOnInit() {
    this.shipmentService
      .GetPODContacts(this.shipmentId, this.userId, this.key)
      .subscribe((results) => {
        this.contactsNationex = results;
        this.filteredContacts = this.contactCtrl.valueChanges.pipe(
          startWith(null),
          map((contact: string) =>
            contact ? this._filter(contact) : this.contactsNationex.slice()
          )
        );
      });
  }

  add(event: MatChipInputEvent, inputName): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.contacts.push(value);
    }

    // Clear the input value
    // event.chipInput!.clear();
    inputName.value = '';

    this.contactCtrl.setValue(null);
  }

  remove(contact: string): void {
    const index = this.contacts.indexOf(contact);

    if (index >= 0) {
      this.contacts.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.contacts.push(event.option.value);
    this.contactInput.nativeElement.value = '';
    this.contactCtrl.setValue(null);
  }

  private _filter(value: string): DTOPODContact[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();

      return this.contactsNationex.filter((contact) =>
        contact.NameAndTitle.toLowerCase().includes(filterValue)
      );
    }
    return null;
  }

  send() {
    this.submitted = false;

    let emails = '';
    if (this.contacts != undefined && this.contacts.length > 0)
      for (let selected of this.contacts) {
        emails = emails + selected + ';';
      }
    emails = emails + this.contactsText;
    this.shipmentService
      .SendPODContacts(this.shipmentId, this.userId, emails, this.key)
      .subscribe((results) => {
        this.dialogRef.close(false);
      });
  }

  close() {
    this.dialogRef.close(false);
  }

  onChange(event) {
    console.log(event);
  }
}
